<template>
    <div class="videos">
        <div class="container">
            <div class="video" v-for="(video, index) in videos" :key="index">
                <figure>
                    <iframe :src="'https://www.youtube.com/embed/'+video.url" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="videos-play"></iframe>
                    <figcaption>
                        <div class="article-header">
                            <tag text="Videos" class="bg-secondary italic" />
                            <p>
                                por <span>UGT-SP</span> - YouTube
                            </p>
                        </div>
                        <div class="videos-text">
                            <h3>{{video.titulo}}</h3>
                            <p>{{video.descricao}}</p>
                        </div>
                    </figcaption>
                </figure>
                <div class="border-separator"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Tag from './tag'
import axios from 'axios'
export default {
    name: 'video-container',
    components: {
        Tag,
    },
    data() {
        return {
            videos: []
        }
    },
    created() {
        this.buscarVideos()
    },
    methods: {
        buscarVideos() {
            axios.get('get-videos-index')
                .then(res => {
                    this.videos = res.data.video
                })
        }
    },
}
</script>

<style scoped lang="scss">
.videos {
    @media (max-width: 639px)
    {
        @apply flex flex-col w-full justify-between;
        figure {
            @apply mb-5 mx-auto;
        }
        iframe{
            @apply rounded-lg mx-auto w-full h-64;
        }
    }
    @media (min-width: 640px) {
        .container {
            @apply mx-auto flex justify-between;
            max-width: 1280px;
        }
        .video {
            @apply  px-6 border-r-2 border-light-gray w-full;
        }
        .video:last-child {
            @apply border-r-0;
        }
        iframe {
            @apply w-full rounded-lg;
        }
        &-play {
            width: 560px;
            height: calc(560px * 9/16);
        }
    }
    span {
        @apply text-primary;
    }
}
.article-header {
    @apply flex flex-row justify-between items-center py-2 px-0;
    p{
        @apply text-xs;
        span {
            @apply text-primary text-sm;
        }
    }
}
</style>
